import { isEmpty, isUndefined, isNull, get, isObject } from "lodash";
export function getVal(object, key, defaultValue) {
  const data = get(object, key);
  if (empty(data)) {
    return defaultValue;
  }
  return data;
}
function empty(obj) {
  if (isUndefined(obj) || isNull(obj)) {
    return true;
  }
  if (isObject(obj)) {
    return isEmpty(obj);
  }
  return obj === "";
}
